module.exports = __webpack_public_path__ + "media/price_bot/chatIcon-1bf93b55.svg";